import { render, staticRenderFns } from "./GoodsBox.vue?vue&type=template&id=68ed2885&scoped=true&"
import script from "./GoodsBox.vue?vue&type=script&lang=js&"
export * from "./GoodsBox.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBox.vue?vue&type=style&index=0&id=68ed2885&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed2885",
  null
  
)

export default component.exports